import React, {Component} from 'react';
import {Row, Col, Modal, Checkbox, Table, Button, DatePicker, Input, Form, Select} from 'antd';
import {api, app} from "../app";
import PropTypes from 'prop-types';
import moment from 'moment';
import _ from 'underscore';
import utils from "../utils";
import TrainSelPalyer from "./TrainSelPalyer";
import locale from 'antd/lib/date-picker/locale/zh_CN';

const FormItem = Form.Item;
const Option = Select.Option;

class TrainSelUser extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedRowKeys: [],
            playerList: [],
            classList: [],
            visible: false,
        };
    }

    /**
     * 设置值
     * @param obj
     */
    setData = (obj, cb) => {
        if (this._isMounted) {
            this.setState(obj, () => {
                if (cb) cb();
            });
        }
    }

    async componentDidMount() {
        this._isMounted = true;
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    componentWillReceiveProps(props) {
        let {visible, id} = props;
        if (visible !== this.state.visible) {
            if (visible) {
                this.SelUserData(id);
            }
            this.setData({visible});
        }
    }

    /**
     * 关闭列表
     */
    handleClose = () => {
        this.props.close();
        this.setData({loading: false, playerList: [], selectedRowKeys: [], train_id: ""}, () => {
            this.props.form.resetFields();
        });
    }

    handleConfirm = () => {

    }

    /**
     * 选人人员
     * @param train_id
     * @returns {Promise<void>}
     * @constructor
     */
    SelUserData = (train_id) => {
        this.setData({loading: true}, async () => {
            const params = {
                train_id,
                indexno: app.getData("indexno"),
                account: app.getData("account"),
            };
            let {flag, data, msg} = await app.post(api.SelectUserList, params);
            if (flag === 1) {
                this.setData({playerList: utils.addArrayKey(data.user_list || []), classList: data.train_class});

            } else {
                app.alert(msg, "error");
            }
            this.setData({loading: false, train_id});
        });
    }

    /**
     * 提交数据
     * @param e
     */
    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, {date, train_site, class_id, class_name}) => {
            if (!err) {
                this.setData({submit_loading: true}, async () => {
                    let {train_id, selectedRowKeys, playerList} = this.state, params = {
                        train_id,
                        class_id,
                        class_name,
                        train_site,
                        startdate: date[0].format("YYYY-MM-DD HH:00:00"),
                        endate: date[1].format("YYYY-MM-DD HH:00:00"),
                        indexno: app.getData("indexno"),
                        account: app.getData("account"),
                    };
                    if (!selectedRowKeys || selectedRowKeys.length === 0) {
                        app.alert("请选择人员！", "warn");
                        return;
                    }
                    console.log(selectedRowKeys);
                    params.user = selectedRowKeys.map((key) => {
                        let p = playerList[key - 1] || {};
                        return p.indexno;
                    }).join(',');
                    let {flag, msg} = await app.post(api.SelectUser, params);
                    if (flag === 1) {
                        app.alert("操作成功", "success");
                        await this.SelUserData(train_id);
                        this.handleClose();
                    } else {
                        app.alert(msg, "warn");
                    }
                    this.setData({submit_loading: false});
                });
            }
        });
    }

    /**
     * 选择班级变更
     * @param value
     */
    handleClassChange = (value) => {
        let {setFieldsValue} = this.props.form,
            {classList} = this.state,
            // classList = [{id: '6', class_name: '测试', train_site: '美国纽约', startdate: '2019-02-06 09:00:00', endate: '2019-03-06 09:00:00'}],
            obj = {
                class_name: '',
                train_site: '',
                date: [],
            };
        if (value !== '0') {
            let index = classList.findIndex((c) => c.id === value);
            if (index !== -1) {
                let {class_name, train_site, startdate, endate} = classList[index];
                obj.class_name = class_name;
                obj.train_site = train_site;
                obj.date = [moment(startdate, "YYYY-MM-DD HH:mm:ss"), moment(endate, "YYYY-MM-DD HH:mm:ss")];
            }
        }
        setFieldsValue(obj);
    }

    render() {
        let {selectedRowKeys, playerList, loading, submit_loading, classList} = this.state,
            {visible, form} = this.props,
            {getFieldDecorator, getFieldValue} = form,
            class_id = getFieldValue('class_id'),
            formItemLayout = {
                labelCol: {
                    xs: {span: 24},
                    sm: {span: 3},
                },
                wrapperCol: {
                    xs: {span: 24},
                    sm: {span: 20, offset: 1},
                },
            },
            columns = [
                {
                    title: '姓名',
                    dataIndex: 'vname',
                    key: 'vname',
                    width: '15%',
                },
                {
                    title: '所属地区',
                    dataIndex: 'province',
                    key: 'province',
                    width: '15%',
                },
                {
                    title: '所属队伍',
                    dataIndex: 'teamname',
                    key: 'teamname',
                    width: '30%',
                },
                {
                    title: '支付时间',
                    dataIndex: 'pay_time',
                    key: 'pay_time',
                    width: '20%',
                    render(text) {
                        return (<span>{text || "无记录"}</span>);
                    }
                },
                {
                    title: '支付情况',
                    dataIndex: 'pay_status',
                    key: 'pay_status',
                    width: '10%',
                    render(status) {
                        switch (status) {
                            case "0":
                                return (<span>未支付</span>);
                            case "1":
                                return (<span>已支付</span>);
                            case "2":
                                return (<span>已退款</span>);
                        }
                    }
                },
                {
                    title: '审核状态',
                    dataIndex: 'apply_status',
                    key: 'apply_status',
                    width: '10%',
                    render(text) {
                        return (<span>{text === "0" ? "未通过" : "已通过"}</span>);
                    }
                },
            ];
        return (
            <Modal
                visible={visible}
                onCancel={this.handleClose}
                footer={
                    <Row>
                        <Col span={12} style={{textAlign: 'left'}}>
                            <Checkbox
                                checked={playerList.length !== 0 && selectedRowKeys.length === playerList.length}
                                onChange={(e) => {
                                    let {checked} = e.target;
                                    let selectedRowKeys = [];
                                    if (checked) {
                                        selectedRowKeys = _.range(1, playerList.length + 1);
                                    }
                                    this.setData({selectedRowKeys});
                                }}
                            > 全选</Checkbox>
                        </Col>
                        <Col>
                            <Button disabled={selectedRowKeys.length === 0} loading={submit_loading}
                                    onClick={(e) => this.handleSubmit(e)}>确定</Button>
                        </Col>
                    </Row>
                }
                width={1000}
                keyboard={false}
                maskClosable={false}
                destroyOnClose={true}
                title={<div style={{textAlign: "center"}}>选人列表</div>}
            >
                <Form>
                    <FormItem
                        label="选择班级"
                        {...formItemLayout}
                    >
                        {getFieldDecorator('class_id', {
                            rules: [{required: true, message: '请选择班级！'}],
                            initialValue: '0'
                        })(
                            <Select placeholder="请选择" style={{width: 400}} onChange={this.handleClassChange}>
                                <Option value="0">创建班级</Option>
                                {
                                    classList.map((c, i) => {
                                        return (
                                            <Option key={i} value={c.id}>{c.class_name}</Option>
                                        );
                                    })
                                }
                            </Select>
                        )}
                    </FormItem>
                    <FormItem
                        label="班级名称"
                        {...formItemLayout}
                    >
                        {getFieldDecorator('class_name', {
                            rules: [{required: true, message: '请填写班级名称！'}],
                        })(
                            <Input placeholder="填写班级名称" style={{width: 400}} readOnly={class_id !== '0'}/>
                        )}
                    </FormItem>
                    <FormItem
                        label="培训地点"
                        {...formItemLayout}
                    >
                        {getFieldDecorator('train_site', {
                            rules: [{required: true, message: '请填写培训地址！'}],
                        })(
                            <Input placeholder="填写培训地点" style={{width: 400}} readOnly={class_id !== '0'}/>
                        )}
                    </FormItem>
                    <FormItem
                        label="培训时间"
                        {...formItemLayout}
                    >
                        {getFieldDecorator('date', {
                            rules: [{required: true, message: '请选择培训时间！'}],
                        })(
                            <DatePicker.RangePicker
                                showTime={{format: "YYYY-MM-DD HH"}}
                                disabledDate={(current) => {
                                    return current && current < moment().endOf('day');
                                }}
                                format="YYYY年MM月DD日 HH时"
                                placeholder={['开始日期', '结束日期']}
                                style={{width: 400}}
                                locale={locale}
                                disabled={class_id !== '0'}
                            />
                        )}
                    </FormItem>
                </Form>
                <Table
                    columns={columns}
                    locale={app.tbLocale(loading)}
                    loading={loading}
                    dataSource={playerList}
                    scroll={{y: 600}}
                    pagination={false}
                    size="small"
                    rowSelection={{
                        selectedRowKeys,
                        onChange: (selectedRowKeys) => {
                            this.setData({selectedRowKeys});
                        },
                    }}
                />
            </Modal>
        );
    }
}

TrainSelPalyer.propTypes = {
    id: PropTypes.any,
    visible: PropTypes.any,
    close: PropTypes.func,
};

export default Form.create()(TrainSelUser);



// WEBPACK FOOTER //
// ./src/components/TrainSelUser.jsx